import {
  FETCH_PRODUCTION_ACCUMULATED_REQUEST,
  FETCH_PRODUCTION_ACCUMULATED_SUCCESS,
  FETCH_PRODUCTION_ACCUMULATED_FAILURE,
  FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST,
  FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS,
  FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE,
  FETCH_JOB_HOURS_REQUEST,
  FETCH_JOB_HOURS_SUCCESS,
  FETCH_JOB_HOURS_FAILURE,
} from "../constants/ProductionConstant";

import Accumulated from "../service/ProductionService";

export const fetchProductionAccumulated = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PRODUCTION_ACCUMULATED_REQUEST });

    const data = await Accumulated.GetActultimeduration();

    dispatch({
      type: FETCH_PRODUCTION_ACCUMULATED_SUCCESS,
      payload: data.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PRODUCTION_ACCUMULATED_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchIwoGroupByAdditional = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST });

    const response = await Accumulated.GetIwoGroupByAdditional();

    dispatch({
      type: FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch IWO groups",
    });
  }
};

export const fetchJobHours = (iwoList) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_JOB_HOURS_REQUEST });

    const response = await Accumulated.GetJobHours(iwoList);

    dispatch({
      type: FETCH_JOB_HOURS_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_JOB_HOURS_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch Job Hours",
    });
  }
};
